/** UI-only flag, never store user-entered content here. */
export function onboardingKey(slug: string): string {
  return `jari-tool-${slug}-onboarded`;
}

export function hasCompletedOnboarding(slug: string): boolean {
  try {
    return localStorage.getItem(onboardingKey(slug)) === "1";
  } catch {
    return false;
  }
}

export function setOnboardingComplete(slug: string): void {
  try {
    localStorage.setItem(onboardingKey(slug), "1");
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearOnboarding(slug: string): void {
  try {
    localStorage.removeItem(onboardingKey(slug));
  } catch {
    /* ignore */
  }
}
